// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  versonaId: __t.u64().primaryKey().name("versona_id"),
  worldId: __t.u64().name("world_id"),
  leanX10: __t.i32().name("lean_x_10"),
  updatedAt: __t.timestamp().name("updated_at"),
});
